module.exports = __webpack_public_path__ + "img/star-empty.0bdb9adb.svg";